import { mainApi } from "services/main";
import {
  GetScanJobRequest,
  GetScanJobResponse,
  GetScanResultRequest,
  GetScanResultResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getScanjob: builder.query<GetScanJobResponse, GetScanJobRequest>({
      query: (request: GetScanJobRequest) => ({
        url: "scan-jobs/" + request.shortId,
      }),
    }),
    getScanResult: builder.query<GetScanResultResponse, GetScanResultRequest>({
      query: (request: GetScanResultRequest) => ({
        url: "scan-result/" + request.shortId,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetScanjobQuery, useGetScanResultQuery } = extendedApi;
